// MUI
import { Stack, Typography } from "@mui/material";

// Components
import { CheckboxWithSwitch } from "@Settings/components/SystemSettings/GeneralContainer/sections/SalesLog/InitialDataFilter/CheckboxWithSwitch";

// Types
import { IFilterConfiguration, ISaleLogDataFilter } from "@Settings/types/Common/model";

// Constants
const FILTER_CATEGORIES = ["Fleet", "Wholesale", "Retail", "Lease", "Dealer Trade"] as const;

type FilterRowProps = {
	isLoading: boolean;
	activeTabName: string;
	data?: ISaleLogDataFilter;
	// Callbacks
	onUpdateInitialDataFilter: (tab: string, category: string, config: IFilterConfiguration) => void;
};

export default function FilterRow(props: Readonly<FilterRowProps>) {
	const {
		isLoading,
		activeTabName,
		data,
		// Callbacks
		onUpdateInitialDataFilter,
	} = props;

	return (
		<Stack direction={"row"} spacing={3}>
			<Stack spacing={2.5} pt={1.5}>
				<Typography variant={"appLabel"}>Include: </Typography>
				<Typography variant={"appLabel"}>Enable: </Typography>
			</Stack>
			<Stack direction="row" alignItems="center" spacing={2}>
				{FILTER_CATEGORIES.map((category) => {
					return (
						<CheckboxWithSwitch
							key={category}
							isLoading={isLoading}
							activeTabName={activeTabName}
							category={category}
							filterConfiguration={data?.filterOptions.find((conf) => conf.name === category) as IFilterConfiguration}
							// Callbacks
							onUpdateInitialDataFilter={onUpdateInitialDataFilter}
						/>
					);
				})}
			</Stack>
		</Stack>
	);
}
